module.exports = __webpack_public_path__ + "img/Telegram-logo.55fbc3a2.webp";